import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, FileText, Shield, FileSignature } from 'lucide-react';
export function OfferSection() {
  return <section className="py-20 px-4 bg-navy-800" data-id="element-166">
      <div className="max-w-5xl mx-auto" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-168">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-169">
            Presentando el{' '}
            <span className="text-gold-500" data-id="element-170">
              Protocolo Adiós Deudas Chile 2025
            </span>
          </h2>
          <p className="text-xl text-gray-300" data-id="element-171">
            He empaquetado todo mi conocimiento legal y financiero. Esto es
            exactamente lo que vas a recibir hoy:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-172">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/eZsr2XvZZA7C7bB1ET44YZ/foto_principal_2.png" alt="Protocolo Adiós Deudas" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-174" />
          </motion.div>

          <div className="space-y-6" data-id="element-175">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-navy-900 p-6 rounded-xl border border-gold-500/30 flex gap-4" data-id="element-176">
              <Shield className="text-gold-500 flex-shrink-0 w-8 h-8" data-id="element-177" />
              <div data-id="element-178">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-179">
                  Guía de Blindaje de Sueldo
                </h3>
                <p className="text-gray-400 text-sm mb-2" data-id="element-180">
                  Cómo proteger tu dinero legalmente de los embargos
                  automáticos.
                </p>
                <p className="text-gold-400 font-semibold text-sm" data-id="element-181">
                  Valor Normal: $25.000 CLP
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}
// Helper icon component since BookOpen was imported from lucide-react but I want a specific look
function BookIcon(props: any) {
  return <FileText {...props} data-id="element-182" />;
}